if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const container = this.querySelector('[role="document"]');
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        // activeMedia may be nested inside a wrapper (e.g. .nauma-modal-media-item)
        // rather than being a direct child of the container itself, so find whichever
        // direct child actually holds it and toggle `.active` there — that's the
        // element the mobile display:none rule keys off of.
        const activeItem = Array.from(container.children).find((child) => child.contains(activeMedia));

        Array.from(container.children).forEach((child) => child.classList.remove('active'));
        if (activeItem) activeItem.classList.add('active');

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.scrollIntoView();

        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
